import { VehicleConsumableGroup } from '~/shared';
import breaks from '../../assets/images/break.svg';
import engine from '../../assets/images/engine.svg';
import oil from '../../assets/images/oil.svg';
import tires from '../../assets/images/tires.svg';
import transmission from '../../assets/images/transmission.svg';

export const CategoryNames: Record<VehicleConsumableGroup | 'engine', string> =
	{
		['engine']: 'Кап. ремонт',
		[VehicleConsumableGroup.MOTOR_OIL]: 'Масло',
		[VehicleConsumableGroup.TRANSMISSION_OIL]: 'Масло КПП',
		[VehicleConsumableGroup.BRAKE_PADS]: 'Колодки',
		[VehicleConsumableGroup.TIRES]: 'Шины',
	};

export const CategoryImages: Record<VehicleConsumableGroup | 'engine', string> =
	{
		['engine']: engine,
		[VehicleConsumableGroup.MOTOR_OIL]: oil,
		[VehicleConsumableGroup.TRANSMISSION_OIL]: transmission,
		[VehicleConsumableGroup.BRAKE_PADS]: breaks,
		[VehicleConsumableGroup.TIRES]: tires,
	};

export const categories = [
	{
		id: 0,
		type: 'engine',
		name: CategoryNames['engine'],
		image: CategoryImages['engine'],
	},
	{
		id: 1,
		type: VehicleConsumableGroup.MOTOR_OIL,
		name: CategoryNames[VehicleConsumableGroup.MOTOR_OIL],
		image: CategoryImages[VehicleConsumableGroup.MOTOR_OIL],
	},
	{
		id: 2,
		type: VehicleConsumableGroup.TRANSMISSION_OIL,
		name: CategoryNames[VehicleConsumableGroup.TRANSMISSION_OIL],
		image: CategoryImages[VehicleConsumableGroup.TRANSMISSION_OIL],
	},
	{
		id: 3,
		type: VehicleConsumableGroup.BRAKE_PADS,
		name: CategoryNames[VehicleConsumableGroup.BRAKE_PADS],
		image: CategoryImages[VehicleConsumableGroup.BRAKE_PADS],
	},
	{
		id: 4,
		type: VehicleConsumableGroup.TIRES,
		name: CategoryNames[VehicleConsumableGroup.TIRES],
		image: CategoryImages[VehicleConsumableGroup.TIRES],
	},
];

export const getCategoryByType = (
	type: VehicleConsumableGroup | 'engine' | null,
) => {
	return categories.find((category) => category.type === type);
};
